import {Text, TouchableOpacity, View} from 'react-native';

import FastImage from 'src/Utils/FastImage';
import React from 'react';
import {formatNumberDisplayAmount} from 'src/Utils/formatHelper';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {useSelector} from 'react-redux';
import {useUserId} from '../Hooks/reduxHooks';
import {cloudFlareOptimizeImage} from '../Utils/helpers';
import {useExplorerPass} from '../Utils/explorerPassHelper';

const ticketsImage = require('src/Images/standardTicketIcon.png');
// single coin with fox in profile direction
const coinImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648581485_original.png',
  ),
};

const FoxShopIcon = ({coinsTestID = 'coins'}) => {
  console.log('FoxShopIcon rerender');

  const tickets = useSelector((state) => state.user?.info?.tickets);

  const coins = useSelector((state) => state.user?.info?.coins);
  const userId = useUserId();
  const playTestState = useSelector((state) => state.app_info?.playTestState);

  const pass = useExplorerPass();

  let hasValidExplorerPass = !!pass;

  if (playTestState) {
    return <View></View>;
  }

  const handleShopPress = () => {
    userId
      ? navigationRef.navigate('FoxShop')
      : navigationRef.navigate('LoginModal', {
          message: 'You must log in to see your tickets',
        });
  };

  const displayedCoins = formatNumberDisplayAmount(coins);
  var allTicketCount = 0;
  if (tickets) {
    try {
      const ticketsQuanties = Object.values(tickets);
      ticketsQuanties?.map?.((quantity) => {
        allTicketCount += parseInt(quantity);
      });
    } catch (e) {
      // can't parse ticets
    }
  }

  const hasBoth = !!coins && !!allTicketCount;
  return (
    <TouchableOpacity
      nativeID={'foxShopIcon'}
      testID={'foxShopIcon'}
      onPress={() => handleShopPress()}
      style={{
        marginHorizontal: 10,
        paddingBottom: 3,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
      }}>
      <View style={{marginRight: 4}}>
        {!!coins && !hasValidExplorerPass && (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
              marginTop: 2,
              marginRight: hasBoth ? 3 : 0,
            }}>
            <Text
              testID={coinsTestID || 'coins'}
              style={{
                color: global?.color?.gray3,
                fontFamily: global?.font.circular,
                fontSize: hasBoth ? 14 : 16,
              }}>
              {displayedCoins}
            </Text>
            <FastImage
              style={{height: hasBoth ? 20 : 28, width: hasBoth ? 20 : 28}}
              source={coinImage}
              resizeMode={FastImage?.resizeMode?.contain}
            />
          </View>
        )}
        {!!allTicketCount && !hasValidExplorerPass && (
          <View
            testID="tickets"
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}>
            <Text
              testID={'ticketCount'}
              style={{
                color: global?.color?.gray3,
                fontFamily: global?.font.circular,
                fontSize: hasBoth ? 14 : 16,
                textAlign: 'right',
                marginLeft: 9,
              }}>
              {allTicketCount}
            </Text>
            <FastImage
              style={{height: hasBoth ? 28 : 40, width: hasBoth ? 28 : 40}}
              source={ticketsImage}
              resizeMode={FastImage?.resizeMode?.contain}
            />
          </View>
        )}
        {!!hasValidExplorerPass && (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}>
            <Text
              testID={'isMember'}
              style={{
                color: global?.color?.yellow,
                fontFamily: global?.font.circularBold,
                fontSize: hasBoth ? 14 : 16,
                textAlign: 'right',
                marginLeft: 9,
              }}>
              Member
            </Text>
          </View>
        )}
      </View>
      <FastImage
        style={{height: 36, width: 36}}
        source={require('src/Images/FOXBACKPAK.png')}
        resizeMode={FastImage?.resizeMode?.contain}
      />
    </TouchableOpacity>
  );
};

export default FoxShopIcon;
